import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import FileList from '@/modules/FileList/components/fileList/FileList.tsx';
import ListFilter from '@/modules/FileList/components/listFilterSection/ListFilter';
import useFilterChips from '@/modules/FileList/hooks/useFilterChips';
import useFilterQueryParams from '@/modules/FileList/hooks/useFilterQueryParams';
import { myFilesListDefaultQueryOption } from '@/modules/FileList/queries/myFilesList/myFilesListDefaultQueryOption.ts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="در حال اجرا" header="titleHeader" navbar>
      <InProgressListPage />
    </MainLayout>
  );
};

const InProgressListPage = () => {
  const { fileListParams, pageTitle } = useFilterQueryParams();
  const filterChipsList = useFilterChips();
  const { data, fetchNextPage, isError, isPending } = useInfiniteQuery(
    myFilesListDefaultQueryOption(fileListParams),
  );
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <Box pt="20px">
      <ListFilter filterChipsList={filterChipsList} />
      {pageTitle && <TitleDescription mb={16} mt={24}>{pageTitle}</TitleDescription>}
      {data ? (
        <FileList fetchNextPage={fetchNextPage} myFilesData={data} />
      ) : null}
    </Box>
  );
};
